'use client';

import { useField } from 'formik';
import { FC, useState } from 'react';

import { validateEmail } from '@/services/AuthService';

import { InputFormikProps } from './Input.type';
import { InputEmail } from './InputEmail';

/**
 * InputEmailFormik field expected to be used within a Formik context
 */
export const InputEmailFormik: FC<Omit<InputFormikProps<typeof InputEmail>, 'validateSchema'>> = (props) => {
  const [pending, setPending] = useState(false);
  const [field, meta, helpers] = useField<string>({
    name: props.name,
    validate: async (email: string) => {
      if (!props.showClientError) {
        return undefined;
      }
      setPending(true);
      try {
        const { block } = await validateEmail(email, { apiKey: process.env.BFF_API_KEY });

        setPending(false);
        return block ? 'Please enter valid email address' : undefined;
      } catch (error) {
        // skip validation if there is an error
        setPending(false);
        console.error('Error validating email', error);
        return undefined;
      }
    },
  });

  return (
    <InputEmail
      {...props}
      value={field.value}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(value) => helpers.setValue(value)}
      pending={pending}
    />
  );
};
